export const candidatesSubTableLevelFilterList = [
  {
    text: 'Prescreen',
    value: 'Prescreen',
  },
  {
    text: 'Application Received',
    value: 'Application recieved',
  },
];

export const candidatesSubTableLevelStatusFilterListPipeline = [
  {
    text: 'No show',
    value: 'No show',
  },
  {
    text: 'Yet To Attend',
    value: 'yet to attend',
  },
  {
    text: 'Attended',
    value: 'Attended',
  },
  {
    text: 'Applied',
    value: 'Applied',
  },
  {
    text: 'Scheduled',
    value: 'Scheduled',
  },
  {
    text: 'Rescheduled',
    value: 'Rescheduled',
  },
  {
    text: 'Review Pending',
    value: 'Review Pending',
  },
  {
    text: 'Review Completed',
    value: 'Review Completed',
  },
  {
    text: 'Interview Passed',
    value: 'Interview Passed',
  },
  {
    text: 'Interview Failed',
    value: 'Interview Failed',
  },
  {
    text: 'Interview On Hold',
    value: 'Interview On Hold',
  },
];

export const candidatesSubTableLevelStatusFilterListRejected = [
  {
    text: 'Interview Failed',
    value: 'Interview Failed',
  },
];

export const candidatesSubTableLevelStatusFilterListRecent = [
  {
    text: 'No Activity',
    value: 'No Activity',
  },
  {
    text: 'Yet To Attend',
    value: 'yet to attend',
  },
];

export const candidatesSubTableLevelStatusFilterList = [
  {
    text: 'No Activity',
    value: 'No Activity',
  },
  {
    text: 'Yet To Attend',
    value: 'yet to attend',
  },
  {
    text: 'Attended',
    value: 'Attended',
  },
  {
    text: 'Applied',
    value: 'Applied',
  },
  {
    text: 'Scheduled',
    value: 'Scheduled',
  },
  {
    text: 'Rescheduled',
    value: 'Rescheduled',
  },
  {
    text: 'Review Pending',
    value: 'Review Pending',
  },
  {
    text: 'Review Completed',
    value: 'Review Completed',
  },
  {
    text: 'Interview Passed',
    value: 'Interview Passed',
  },
  {
    text: 'Interview Failed',
    value: 'Interview Failed',
  },
  {
    text: 'Interview On Hold',
    value: 'Interview On Hold',
  },
];

export const candidatesSubTableSourceFilterList = [
  {
    text: 'Manual Upload',
    value: 'Manual Upload',
  },
  {
    text: 'Excel Upload',
    value: 'Excel Upload',
  },
];

export const reviewPendingStatus = [
  {
    text: 'Pending For Review',
    value: 'pending_for_review',
  },
  {
    text: 'AI Progress',
    value: 'INITIATED',
  },
];

export const genderList = [
  {
    text: 'Male',
    value: 'male',
  },
  {
    text: 'Female',
    value: 'female',
  },
  {
    text: 'Any',
    value: 'any',
  },
];

export const yesOrNoFilter = [
  {
    text: 'Yes',
    value: 'yes',
  },
  {
    text: 'No',
    value: 'no',
  },
];

export const questionBankSourceFilter = [
  {
    text: 'AI',
    value: 'ai',
  },
  {
    text: 'Excel',
    value: 'excel',
  },
  {
    text: 'Custom',
    value: 'custom',
  },
];

export const priorityFilter = [
  {
    text: 'High',
    value: 'high',
  },
  {
    text: 'Medium',
    value: 'medium',
  },
  {
    text: 'Low',
    value: 'low',
  },
];

export const candidatesSubTableConfig = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Grade',
    dataIndex: 'resume_score',
    key: 'resume_score',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
    align: 'center',
  },
  {
    fixed: '',
    width: 200,
    title: 'Current Level',
    dataIndex: 'current_level',
    key: 'current_level',
    fieldShow: true,
    isExpanded: false,
    is_sort: true,
    is_search: false,
    is_filter: true,
    dynamic_filter: true,
    // filters: candidatesSubTableLevelFilterList,
    position: 4,
  },
  {
    fixed: '',
    width: 200,
    title: 'Total Experience',
    dataIndex: 'total_exp',
    key: 'total_exp',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 5,
  },
  {
    fixed: '',
    width: 200,
    title: 'Skill',
    dataIndex: 'skills',
    key: 'skills',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Current Level Status',
    dataIndex: 'current_level_status',
    key: 'current_level_status',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_filter: true,
    dynamic_filter: false,
    filters: candidatesSubTableLevelStatusFilterListPipeline,
    is_sort: true,
    position: 8,
  },
  {
    fixed: '',
    width: 200,
    title: 'Source',
    dataIndex: 'registration_source',
    key: 'registration_source',
    fieldShow: true,
    isExpanded: false,
    is_sort: true, // add filters field in the component because of API dependency.
    position: 9,
  },
  {
    fixed: '',
    width: 200,
    title: 'Created Date',
    dataIndex: 'created',
    key: 'created',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 10,
  },
  {
    fixed: '',
    width: 200,
    title: 'Created Time',
    dataIndex: 'created_time',
    key: 'created_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 11,
  },
];

export const candidatesSubTableConfigRejected = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Grade',
    dataIndex: 'resume_score',
    key: 'resume_score',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
    align: 'center',
  },
  {
    fixed: '',
    width: 200,
    title: 'Current Level',
    dataIndex: 'current_level',
    key: 'current_level',
    fieldShow: true,
    isExpanded: false,
    is_sort: true,
    is_search: false,
    is_filter: true,
    dynamic_filter: true,
    // filters: candidatesSubTableLevelFilterList,
    position: 4,
  },
  {
    fixed: '',
    width: 200,
    title: 'Current Level Status',
    dataIndex: 'current_level_status',
    key: 'current_level_status',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_filter: true,
    dynamic_filter: false,
    filters: candidatesSubTableLevelStatusFilterListRejected,
    is_sort: true,
    position: 5,
  },
  {
    fixed: '',
    width: 200,
    title: 'Source',
    dataIndex: 'registration_source',
    key: 'registration_source',
    fieldShow: true,
    isExpanded: false,
    is_sort: true, // add filters field in the component because of API dependency.
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Rejected Date',
    dataIndex: 'rejected',
    key: 'rejected',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Rejected Time',
    dataIndex: 'reject_time',
    key: 'reject_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 8,
  },
];

export const candidatesSubTableConfigRecent = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Grade',
    dataIndex: 'resume_score',
    key: 'resume_score',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
    align: 'center',
  },
  {
    fixed: '',
    width: 200,
    title: 'Current Level',
    dataIndex: 'current_level',
    key: 'current_level',
    fieldShow: true,
    isExpanded: false,
    is_sort: true,
    is_search: false,
    is_filter: true,
    dynamic_filter: false,
    filters: candidatesSubTableLevelFilterList,
    position: 4,
  },
  {
    fixed: '',
    width: 200,
    title: 'Current Level Status',
    dataIndex: 'current_level_status',
    key: 'current_level_status',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_filter: true,
    dynamic_filter: false,
    filters: candidatesSubTableLevelStatusFilterListRecent,
    is_sort: true,
    position: 5,
  },
  {
    fixed: '',
    width: 200,
    title: 'Total Experience',
    dataIndex: 'total_exp',
    key: 'total_exp',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Skill',
    dataIndex: 'skills',
    key: 'skills',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 8,
  },
  {
    fixed: '',
    width: 200,
    title: 'Source',
    dataIndex: 'registration_source',
    key: 'registration_source',
    fieldShow: true,
    isExpanded: false,
    is_sort: true, // add filters field in the component because of API dependency.
    position: 9,
  },
  {
    fixed: '',
    width: 200,
    title: 'Applied Date',
    dataIndex: 'created',
    key: 'created',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 10,
  },
  {
    fixed: '',
    width: 200,
    title: 'Applied Time',
    dataIndex: 'created_time',
    key: 'created_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 11,
  },
];

export const candidatesSubTableConfigConflict = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Grade',
    dataIndex: 'resume_score',
    key: 'resume_score',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
    align: 'center',
  },
  // {
  //   fixed: '',
  //   width: 200,
  //   title: 'Current Level',
  //   dataIndex: 'current_level',
  //   key: 'current_level',
  //   fieldShow: true,
  //   isExpanded: false,
  //   is_sort: true,
  //   is_search: false,
  //   is_filter: true,
  //   dynamic_filter: true,
  //   // filters: candidatesSubTableLevelFilterList,
  //   position: 4,
  // },
  // {
  //   fixed: '',
  //   width: 200,
  //   title: 'Current Level Status',
  //   dataIndex: 'current_level_status',
  //   key: 'current_level_status',
  //   fieldShow: true,
  //   isExpanded: false,
  //   is_search: false,
  //   is_filter: true,
  //   dynamic_filter: false,
  //   filters: candidatesSubTableLevelStatusFilterList,
  //   is_sort: true,
  //   position: 5,
  // },
  {
    fixed: '',
    width: 200,
    title: 'Source',
    dataIndex: 'registration_source',
    key: 'registration_source',
    fieldShow: true,
    isExpanded: false,
    is_sort: true, // add filters field in the component because of API dependency.
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Applied Date',
    dataIndex: 'created',
    key: 'created',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Applied Time',
    dataIndex: 'created_time',
    key: 'created_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 8,
  },
];

export const consultancyCandidateTableColumnData = [
  {
    fieldID: 'id',
    headerName: 'ID',
  },
  {
    fieldID: 'first_name',
    headerName: 'First Name',
  },
  {
    fieldID: 'last_name',
    headerName: 'Last Name',
  },
  {
    fieldID: 'email',
    headerName: 'Email',
  },
  {
    fieldID: 'mobile_number',
    headerName: 'Phone',
  },
  {
    fieldID: 'resume_score',
    headerName: 'Score',
  },
  {
    fieldID: 'consultancy',
    headerName: 'Consultancy',
  },
  {
    fieldID: 'created_date',
    headerName: 'Created Date',
  },
  {
    fieldID: 'created_time',
    headerName: 'Created Time',
  },
];

export const mainCandidatesTableConfig = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Grade',
    dataIndex: 'resume_score',
    key: 'resume_score',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
    align: 'center',
  },
  {
    fixed: '',
    width: 200,
    title: 'Source',
    dataIndex: 'registration_source',
    key: 'registration_source',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 4,
  },
  {
    fixed: '',
    width: 200,
    title: 'Total Experience',
    dataIndex: 'total_exp',
    key: 'total_exp',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 5,
  },
  {
    fixed: '',
    width: 200,
    title: 'Skill',
    dataIndex: 'skills',
    key: 'skills',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Industries',
    dataIndex: 'industries',
    key: 'industries',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Last Company',
    dataIndex: 'last_company',
    key: 'last_company',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 8,
  },
  {
    fixed: '',
    width: 200,
    title: 'Last Designation',
    dataIndex: 'last_designation',
    key: 'last_designation',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 9,
  },
  {
    fixed: '',
    width: 200,
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 10,
  },
  {
    fixed: '',
    width: 200,
    title: 'Created Date',
    dataIndex: 'created_date',
    key: 'created_date',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 11,
  },
  {
    fixed: '',
    width: 200,
    title: 'Created Time',
    dataIndex: 'created_time',
    key: 'created_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 12,
  },
  // {
  //   fixed: 'right',
  //   width: 90,
  //   title: 'Actions',
  //   dataIndex: 'actions',
  //   key: 'actions',
  //   fieldShow: true,
  //   isExpanded: false,
  //   is_search: false,
  //   is_sort: false,
  //   is_filter: false,
  //   position: 13,
  // },
];

export const pipelineComponentColumnData = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'fullname',
    key: 'fullname',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Job',
    dataIndex: 'job',
    key: 'job',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
  },
  {
    width: 200,
    title: 'Level',
    dataIndex: 'level',
    key: 'level',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 4,
  },
  {
    fixed: '',
    width: 200,
    title: 'Total Experience',
    dataIndex: 'total_exp',
    key: 'total_exp',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 5,
  },
  {
    fixed: '',
    width: 200,
    title: 'Skill',
    dataIndex: 'skills',
    key: 'skills',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Created Date',
    dataIndex: 'created_date',
    key: 'created_date',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 8,
  },
  {
    fixed: '',
    width: 200,
    title: 'Created Time',
    dataIndex: 'created_time',
    key: 'created_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 9,
  },
  {
    width: 200,
    title: 'Status',
    dataIndex: 'level_status',
    key: 'level_status',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 10,
  },
  {
    fixed: 'right',
    width: 90,
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_sort: false,
    is_filter: false,
    position: 11,
  },
];

export const noShowCandidatesColumns = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'first_name',
    key: 'first_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Job',
    dataIndex: 'job',
    key: 'job',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
  },
  {
    width: 200,
    title: 'Level',
    dataIndex: 'level',
    key: 'level',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 4,
  },
  {
    fixed: '',
    width: 200,
    title: 'Skill',
    dataIndex: 'skills',
    key: 'skills',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 5,
  },
  {
    fixed: '',
    width: 200,
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 6,
  },
  {
    fixed: '',
    width: 200,
    title: 'Scheduled Date',
    dataIndex: 'scheduled_date',
    key: 'scheduled_date',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    colType: 'date',
    position: 7,
  },
  {
    fixed: '',
    width: 200,
    title: 'Scheduled Time',
    dataIndex: 'scheduled_time',
    key: 'scheduled_time',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 8,
  },
  {
    fixed: 'right',
    width: 150,
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_sort: false,
    is_filter: false,
    position: 9,
  },
];
export const hiredMemberColumns = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: 'right',
    width: 150,
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_sort: false,
    is_filter: false,
    position: 3,
  },
];
export const resumeParsingReportColumns = [
  {
    fixed: '',
    width: 200,
    title: 'Name',
    dataIndex: 'full_name',
    key: 'full_name',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 0,
  },
  {
    fixed: '',
    width: 200,
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 1,
  },
  {
    fixed: '',
    width: 200,
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 2,
  },
  {
    fixed: '',
    width: 200,
    title: 'Source',
    dataIndex: 'source',
    key: 'source',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
  },
  {
    fixed: '',
    width: 200,
    title: 'Skills',
    dataIndex: 'skills',
    key: 'skills',
    fieldShow: true,
    isExpanded: false,
    is_search: true,
    is_sort: true,
    is_filter: false,
    position: 3,
  },
  {
    fixed: 'right',
    width: 150,
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    fieldShow: true,
    isExpanded: false,
    is_search: false,
    is_sort: false,
    is_filter: false,
    position: 3,
  },
];
export const TYPES = {
  SET_RESUME_FILES: 'SET_RESUME_FILES',
  SET_SEARCH_DATA: 'SET_SEARCH_DATA',
  SET_SELECTED_JOB_ITEMS: 'SET_SELECTED_JOB_ITEMS',
  SET_ADD_CANDIDATES_MODAL_OPEN: 'SET_ADD_CANDIDATES_MODAL_OPEN',
  SET_ADD_CANDIDATES_TABLE_MODAL_OPEN:
    'SET_ADD_CANDIDATES_TABLE_MODAL_OPEN',
  RESET_RESUMES_FILE_UPLOAD: 'RESET_RESUMES_FILE_UPLOAD',
  SET_RESUMES_FILE_UPLOAD: 'SET_RESUMES_FILE_UPLOAD',
  SET_SCHEDULE_MODAL_OPEN: 'SET_SCHEDULE_MODAL_OPEN',
  SET_UPDATE_CANDIDATE_MODAL_OPEN: 'SET_UPDATE_CANDIDATE_MODAL_OPEN',
  SET_COMPARE_MODAL_OPEN: 'SET_COMPARE_MODAL_OPEN',
  SET_GRID_SEARCH_TEXT: 'SET_GRID_SEARCH_TEXT',
  SET_JOB_SEARCH_TEXT: 'SET_JOB_SEARCH_TEXT',
};
